import styled, {FlattenSimpleInterpolation, css} from 'styled-components'
import {white, semiDarkGray, airBlue} from '@modifi/colors'
import Picture from '../../ui/cms-picture'

type NumbersCardContentProps = {
  isTextSm?: boolean
  isImgLg?: boolean
  isCentered?: boolean
  colorHex?: string
}

export const NumbersCardContent = styled.div<NumbersCardContentProps>`
  min-height: 250px;
  width: 250px;
  display: inline-flex;
  flex-direction: column;
  justify-content: ${({isCentered}): string => (isCentered ? 'center' : 'space-between')};
  align-items: center;
  background-color: ${white};
  border-radius: 6px;
  box-shadow: 3px 4px 16px rgba(23, 61, 108, 0.11);
  padding: 48px 24px 24px;
  margin-right: 8px;
  margin-left: 8px;

  & > img {
    height: ${({isImgLg}): string => (isImgLg ? '72px' : '56px')};
  }

  & > h2 {
    color: ${({colorHex}): string => colorHex || airBlue};
    font-size: ${({isTextSm}): string => (isTextSm ? '32px' : '56px')};
    margin: ${({isCentered}): string => (isCentered ? '24px 0 8px 0' : '32px 0 16px 0')};
  }

  & > span {
    white-space: break-spaces;
    text-align: center;
    color: ${({colorHex}): string => colorHex || semiDarkGray};
    ${({isTextSm}): FlattenSimpleInterpolation | string =>
      isTextSm
        ? css`
            font-size: 14px;
          `
        : ''}
  }
`

type DummyImageProps = {
  isImgLg?: boolean
}

export const DummyImage = styled.div<DummyImageProps>`
  height: ${({isImgLg}): string => (isImgLg ? '72px' : '56px')};
  width: ${({isImgLg}): string => (isImgLg ? '72px' : '56px')};
`

type RelativeWrapperProps = {
  hasBackgroundImage: boolean
}

export const RelativeWrapper = styled.div<RelativeWrapperProps>`
  position: relative;
  ${({hasBackgroundImage}): FlattenSimpleInterpolation | string =>
    hasBackgroundImage
      ? css`
          min-height: 560px;
          padding: 56px 0 56px 0;
        `
      : ''}
`

export const StyledPicture = styled(Picture)`
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: -20;
`
